export interface FuelPriceIndexType {
  id: number;
  name: string;
}
